import React from 'react';
import { Tab, Tabs, TabsContainer } from '../../common';
import styled from '@emotion/styled';
import { useDispatch, useSelector, connect } from 'react-redux';

const TabContainerWrapper = styled(TabsContainer)`
  ul {
    display: flex;
    justify-content: space-between;
  }
`;

export function RecruitWrapper({ stage, children, handleClick }) {
    const ProjectWebLink = useSelector(state => state.ProjectReducer.resumeData.project_data[0]?.isWebLink);
  let totalRecruitsCount = 0;
    const RecruitsGroupwiseData = useSelector(state => state.RecruitsGroupReducer.FilterRecruitsGroupwise);

if (RecruitsGroupwiseData && Array.isArray(RecruitsGroupwiseData)) {
  totalRecruitsCount = RecruitsGroupwiseData.length;
}

  return (
    <React.Fragment>
      <TabContainerWrapper>
        <div className="row">
          <div className="col-md-8">
            <Tabs>
              {/* <Tab onClick={() => handleClick(1)} active={stage == 1 ? true : false} fontSize="14px">
                Invite
              </Tab> */}
              <Tab
                onClick={() => handleClick(2)}
                active={stage == 2 ? true : false}
                fontSize="14px"
                activeColor="var(--middleGreen)"
              >
                Applied
              </Tab>
              <Tab onClick={() => handleClick(3)} active={stage == 3 ? true : false} fontSize="14px">
                Confirmed
              </Tab>
              <Tab onClick={() => handleClick(4)} active={stage == 4 ? true : false} fontSize="14px">
                Rejected
              </Tab>
              {ProjectWebLink === 1 && (
              <Tab onClick={() => handleClick(5)} active={stage == 5 ? true : false} fontSize="14px">
              {totalRecruitsCount === 0 ? 'Link Visited' : `Link Visited (${totalRecruitsCount})`}
             </Tab>
              )}
            </Tabs>
          </div>
        </div>
        {children}
      </TabContainerWrapper>
    </React.Fragment>
  );
}
